if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.ecoFeesType = this.dataset.ecoFeesType;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async getFeesProduct(handle, price) {
        const formattedPrice = parseFloat(price) * 100;

        const feesProduct = await fetch(`/products/${handle}.js`).then((response) => {
          return response.json();
        });

        console.log('Fees product', feesProduct);

        const closestVariant = feesProduct.variants.reduce((closest, current) => {
          const currentDiff = Math.abs(current.price - formattedPrice);
          const closestDiff = Math.abs(closest.price - formattedPrice);
          return currentDiff < closestDiff ? current : closest;
        });

        return closestVariant;
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        let config;
        let formData;

        if (this.ecoFeesType === 'Bundled') {
          formData = new FormData(this.form);
          for (let [key, value] of formData.entries()) {
            console.log(`${key}:`, value);
          }

          config = fetchConfig('json');
          const ecoFeesProduct = await this.getFeesProduct('eco-fees', formData.get('properties[_eco_fees_price]'));

          const items = [
            {
              id: parseInt(ecoFeesProduct.id, 10),
              quantity: parseInt(formData.get('quantity'), 10) || 1,
              properties: {
                _eco_fees_bundle_type: 'Bundled',
                _eco_fees_price: formData.get('properties[_eco_fees_price]'),
                _eco_fees_bundle_id: formData.get('properties[_eco_fees_bundle_id]'),
                _eco_fees_bundle_parent: 'false',
              },
            },
            {
              id: parseInt(formData.get('id'), 10),
              quantity: parseInt(formData.get('quantity'), 10) || 1,
              properties: {
                _eco_fees_bundle_type: 'Bundled',
                _eco_fees_price: formData.get('properties[_eco_fees_price]'),
                _eco_fees_bundle_id: formData.get('properties[_eco_fees_bundle_id]'),
                _eco_fees_bundle_parent: 'true',
              },
            },
          ];

          const body = JSON.stringify({
            items: items,
            sections: this.cart.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname,
          });

          config.body = body;
        } else {
          config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }

          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              await this.cart.renderContents(response);
            }

            if (!this.error) console.log('LETS PUBLISH');

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });
            this.error = false;
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
